import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useJourney } from "@/v2/V2Shell";

const SECTIONS = [["/journey", "Year", "year", true], ["/journey/progress", "Progress", "progress"], ["/journey/plan", "Plan", "plan"], ["/journey/story", "Story", "story"]];

export default function JourneyLayout() {
  const { s } = useJourney();
  const narrow = useLocation().pathname === "/journey/plan";
  return (
    <div className="space-y-6">
      <div className="rise flex flex-wrap items-end justify-between gap-x-6 gap-y-4">
        <div>
          <p className="eyebrow">Year {s.journey.year} · week {s.week} · chapter {s.journey.phase_index + 1} of 6</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-1">Your journey</h1>
        </div>
        <nav className="flex w-full sm:w-auto p-1 rounded-full bg-[#EFECE6]" data-testid="journey-sections">
          {SECTIONS.map(([to, label, id, end]) => (
            <NavLink key={id} to={to} end={end} data-testid={`journey-tab-${id}`}
              className={({ isActive }) => `flex-1 sm:flex-none min-h-11 inline-flex items-center justify-center px-4 chip rounded-full text-sm ${isActive ? "bg-white shadow-sm font-semibold text-stone-900" : "text-stone-600 hover:text-stone-900"}`}>{label}</NavLink>
          ))}
        </nav>
      </div>
      <div className={narrow ? "max-w-3xl" : ""}><Outlet /></div>
    </div>
  );
}
